module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SL-96caf10be35f5a680bb16599ec1ffca6.png";